import { createAsyncThunk } from "@reduxjs/toolkit";
import revenueService from "../../../api/services/revenue";

export const getMonthlyRevenueByPeriod = createAsyncThunk(
  "revenue/get-monthly-revenue-by-period",
  async ({ startYear, startMonth, endYear, endMonth }) => {
    return await revenueService.getMonthlyRevenueByPeriod({
      startYear,
      startMonth,
      endYear,
      endMonth,
    });
  }
);

export const getMonthlyRevenues = createAsyncThunk(
  "revenue/get-monthly-revenue",
  async () => {
    return await revenueService.getMonthlyRevenues();
  }
);
